import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import Routes from "./routes";
import { FullScreenLoader } from "@app.automotus.io/components/FullScreenLoader";
import { ZendeskWidgetVisibility } from "./components/ZendeskWidgetVisibility";

export const App: React.FC = () => {
  const { isLoading } = useAuth0();
  return (
    <>
      {/* Hoisted above FullScreenLoader (not a child of it) since FullScreenLoader discards
       * its children entirely while loading, and Zendesk's snippet (public/index.html) loads
       * independently of auth state via a plain <script> tag — it can render its launcher
       * before Auth0 resolves, so this needs to stay mounted through the loading screen too.
       * MainLayout renders this visible again for authenticated pages. */}
      <ZendeskWidgetVisibility visible={false} />
      <FullScreenLoader loading={isLoading}>
        <Routes />
      </FullScreenLoader>
    </>
  );
};

export default App;
